export class DocumentsPerFolderModel {
  folderId: string;
  documentIds: string[];
  cutFromFolderId: string;
  isPatientTree = false;
  patientId: string;
  folderIds: string[];
}
